export const API_URL = {
    //GETWAY_API: process.env.REACT_APP_GETWAY_API + 'insurancebox/',
    GETWAY_API: process.env.REACT_APP_GETWAY_API + 'insurancebox/',
    GETWAY_DOCS_API: process.env.REACT_APP_GETWAY_API + 'insurancebox-docs/',
};

export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE
export const APIV = 1;
export const apikey = `insurancebox-ac1faa7b-9fe9-4483-9525-5cc4ce94c639`;
export const CURRENCY_SYMBOL = 'Rp';
export const INSURANCE_LIST_SORT = [
    { label: 'Insurance ID DESC', value: 'id__desc' },
    { label: 'Insurance ID ASC', value: 'id__asc' },
    { label: 'Created Date ASC', value: 'created_at__asc' },
    { label: 'Created Date DESC', value: 'created_at__desc' },
    { label: 'Modified Date ASC', value: 'updated_at__asc' },
    { label: 'Modified Date DESC', value: 'updated_at__desc' }
];

export const WHATSAPP_WEB_URL = "https://web.whatsapp.com/send?text=";

export const APP_TYPE_WITH_UCF = 1;
export const APP_TYPE_STANDALONE = 2;
export const APP_TYPE_RENEWAL = 3;
export const APP_TYPE_AGENCY = 4;

export const DOCUMENT_CATEGORY: any = {
    "firstSubmit": { doc_type_id: 1, childs: { "ktp_id": 1, "vehicle_photos": 2, "stnk_photos":11, "transfer_docs":12 } },
    "disbursal": { doc_type_id: 2, childs: {"policy_shared": 13} },
    "postDisbursal": { doc_type_id: 3, childs: { "insurance_premium_payment":16,"proof_inbound": 14, "proof_outbound": 15,"proof_customer_partner_broker": 17, "payment_from_agency_to_oto_insurance": 63, "payment_from_oto_to_insurance_partner": 64, "payment_from_agency_to_insurance_partner": 65, "payment_from_insurance_partner_to_oto": 66, "referral_fee_payout": 67 }}
}

export const STATUS_SUB_STATUS = {
    "status": {
        "application": 1,
        "sent_to_insurance_broker": 2,
        "insurance_policy": 3,
        "insurance_payment": 4,
        "incentive_payment": 5,
        "insurer_partner_payment":6,
        "lost":7
    },
    "subStatus": {
        "quotation_shared":1,
        "application_created":2,
        "sent_to_insurance_broker":3,
        "policy_generated":4,
        "policy_shared":5,
        "payment_from_customer":6,
        "payment_from_sales_team":7,
        "payment_to_sales_team":8,
        "insurer_partner_payment":9,
        "reject_incorrect_data": 10,
        "reject_junk_application": 11,
        "cancel_by_oto": 12,
        "cancel_by_customer": 13,
        "cancel_by_insurance_partner": 14,
        "other": 15,
        "insurance_policy_cancelled":17,
        "back_order_application":29,
        "policy_terms_finalized":30
    }
}

export const INBOUND_PAYMENT_FROM_CUSTOMER = 3;
export const INBOUND_PAYMENT_FROM_SALES_TEAM = 2;
export const INBOUND_PAYMENT_FROM_BROKER = 1;

export const INBOUND_PAYMENT_FROM_OTO_INSURANCE = 4; //REF FOR INBOUND
export const INBOUND_PAYMENT_FROM_INSURANCE_PARTNER = 5; //REF FOR INBOUND
export const REFERRAL_FEE_PAYOUT = 26; //REF FOR OUTBOUND
export const REFERRAL_FEE_PAYOUT_OUTBOUND = 6; //REF FOR OUTBOUND

export const INSURANCE_PAYMENT_FROM_AGENCY_TO_OTO_INSURANCE = 22;
export const INSURANCE_PAYMENT_FROM_OTO_TO_INSURANCE_PARTNER = 23;

export const INSURANCE_PAYMENT_FROM_AGENCY_TO_INSURANCE_PARTNER = 24;
export const INSURANCE_PAYMENT_FROM_INSURANCE_PARTNER_TO_OTO = 25;


export const OUTBOUND_PAYMENT_TO_SALES_TEAM = 2;
export const OUTBOUND_PAYMENT_TO_BROKER = 1;

export const WITH_UCF_PAYMENT_OPTION = [
    { value: 'customer', label: "Carmudi" },
    { value: 'sales_team', label: "Sales Team" },
    { value: 'broker', label: "Insurance Partner/Broker" }
];

export const AGENCY_PAYMENT_OPTION = [
    { value: 'oto_insurance', label: "OTO Insurance" },
    { value: 'insurance_partner', label: "Insurance Partner" }
];

export const STANDALONE_PAYMENT_OPTION = [
    { value: 'customer', label: "Carmudi" },
    { value: 'broker', label: "Insurance Partner/Broker" }
];

export const PAYMENT_TYPE_INBOUND = 1;
export const PAYMENT_TYPE_OUTBOUND = 2;
export const PAYMENT_TYPE_FROM_CUSTOMER_TO_BROKER = 3;


export const SOFT_APPROVAL_RECEIVED_TYPE = 1;
export const POLICY_GENERATED_TYPE = 2;

export const MAX_FILE_UPLOAD = 2;

export const SHARE_METHOD = { "email": 1, "whatsapp": 2, "viber": 3 };

export const ROLE_FEATURES = {
    "customer_details": 1,
    "personal_details": 2,
    "residential_details": 3,
    "vehicle_details": 4,
    "send_to_insurance_broker": 5,
    "soft_approval_received": 6,
    "insurance_policy_generated": 7,
    "insurance_premium_payment": 7,
    "incentive-payment":7,
    "insurance_policy_shared": 8,
    "inbound_payment": 9,
    "payment_from_customer": 10,
    "payment_from_sales_team": 11,
    "payment_from_insurance_broker": 12,
    "outbound_payment": 13,
    "payment_to_insurance_broker": 14,
    "payment_to_sales_team": 15,
    "lost": 16,
    're-open': 17,
    "insurance_partner_management": 18,
    "task_role_assignment": 19,
    "loan_expected": 20,
    "doc_upload": 21,
    "listing_page": 22,
    "dashboard_page": 23,
    "sent_to_insurance_broker": 24,
    "sent_to_insurance_broker_email": 25,
    "sent_to_insurance_broker_whats_app": 26,
    "sent_to_insurance_broker_viber_template_config": 27,
    "insurance_policy": 28,
    "insurance_policy_shared_email": 29,
    "insurance_policy_shared_whats_app": 30,
    "insurance_policy_shared_viber_template_config": 31,
    "import_module": 32,
    "update_module": 33,
    "assign_lead_to_user": 34,
    "my_cases": 35,
    "other_details": 36,
    "payment_from_customer_to_partner_broker": 37,
    "payment_details": 38,
    "insurance_agency_partner_management": 39,
    "insurance_bulk_payment": 40,
    "bulk_upload_application": 41,
    "insurance_insurer_management":42,
    "policy_terms_finalized":43,
    'insurer_partner_payment': 7
}

export const FIELD_TYPE = {
    TEXT_BOX: 'tb',
    DROP_DOWN: 'dd',
    DROPDOWN_INPUT_FIELD: 'ddtb',
    SEARCHABLE_DROP_DOWN: 'sdd',
    READ_ONLY_TEXT_BOX: 'ro',
    DATE_PICKER: 'date',
    MOBILE_FIELD: 'mobile',
    STICKY_FIELD: "sticky",
    EMAIL: 'email',
    MARKET_MRP: 'market_mrp',
    CITY: 'city',
    STATE: 'state',
    LOCALITY: 'locality',
    RADIO_BOX: 'radio',
    MRP_UPPING: 'mrp_upping',
    CURRENCY: 'currency',
    FUTURE_DATE: 'future_date',
    TELEPHONE: 'telephone',
    CHECK_BOX: 'checkbox',
    SELECT_ADDON: 'select_addon',
    SUM: 'sum',
    TEXT_AREA: 'ta',
    MULTI_DROP_DOWN: 'mdd'
}

export const ADD_ONS_TYPE = {
    BODILY_INJURY: 'bi',
    PROPERTY_DAMAGE: 'pd',
    PERSONAL_ACCIDENT: 'pa',
    RIOTS_STRIKES_CIVIL: 'rsc',
    TOWING_ROWDSIDE: 'tra',
    ACTS_OF_NATURE: 'an'
}

export const INS_TYPE_COMPREHENSIVE = 1;
export const INS_TYPE_CTPL = 2;

export const LEAD_TYPE_SFA_APP = 1
export const LEAD_TYPE_DEALER_APP = 2
export const LEAD_TYPE_WEB_APP = 3

export const WITH_RULE_ENGINE = 1
export const WITHOUT_RULE_ENGINE = 2


export const WITH_RULE_ENGINE_ID = 1;

export const LOST_REASON_FLAGS = ['rej_incorrect_data', 'rej_junk_app', 'carmudi', 'customer', 'ins_partner', 'add_remark'];

export const ROLE = { 5: 'sm_id', 6: 'so_id', 7: 'aro_id', 8: 'agent_id' };

export const LOST_REASON_IDS = [10,11,12,13, 14, 15, 16, 17, 18];

export const DOC_STATUS = { 0: 'Pending', 1: 'Requested', 2: 'Submitted', 3: 'Approved' }
export const AGENT_ROLE_ID = 8;
export const ARO_ROLE_ID = 7;

export const PHILIPPINE_CURRENCY = `&#8369;`;

export const REGEX_EMAIL_VALIDATION = /^[^@]+@[^@]+\.[^@.]{2,15}$/;

export const DOCUMENTS_CATEGORY_INBOUND = {
    '1_installment_file': 15,
    '2_installment_file': 16,
    '3_installment_file': 17,
    '4_installment_file': 18,
    '5_installment_file': 19,
    '6_installment_file': 20,
    '7_installment_file': 21,
    '8_installment_file': 22,
    '9_installment_file': 23,
    '10_installment_file': 24,
    '11_installment_file': 25,
    '12_installment_file': 26
};

export const PAYMENT_TERM_INSTALLMENT = 2;

export const DOCUMENT_CATEGORY_OTHER_DOCUMENT = 27;

export const EFFECTIVITY_EXPIRY_INTERVAL = 60;

export const TEMPLATE_TYPE_BROKER = 1;
export const TEMPLATE_TYPE_POLICY_SHARED = 2;


export const API_TYPES = {
    outboundData: `fetchOutboundPaymentDetails`,
    templateData: `fetchTemplateData`,
    softApprovalData: `fetchSoftApprovalData`,
    policyGeneratedData: `fetchPolicyGeneratedData`,
    inboundData: `fetchInboundPaymentDetails`,
    customerData: `fetchCustomerDetails`
}
export const REGEX_DECIMAL_VALIDATION = /^[0-9]*(\.[0-9]{0,2})?$/;
export const REGEX_DECIMAL_VALIDATION_8 = /^[0-9]*(\.[0-9]{0,8})?$/;

export const ALPHABETIC_PATTERN = /^[ A-Za-z\u00C0-\u024F0-9@.\/#&+\-\*\[\],=;()\p{M}']*$/u //eslint-disable-line
export const MAX_FILE_UPLOAD_POLICY_GENRATED = 5;
export const MIN_DISCOUNT = 10;
export const MAX_DISCOUNT_PERCENT = 0.5; //50 percent

export const CLIENT_REFERRAL = 3;
export const AGENT = 4;
export const DSA = 5;
export const MARKETING = 7;
export const FIVE_YEAR = 5;
export const SIX = 6;
export const TWO_MONTH = 2;


export const EXPECTED_INSTALLMENT = {
    name: 'expected_installment',
    child_depedencies: null,
    data_type: "string",
    error_msg: "Please enter valid date",
    error_message: {},
    field_show: "",
    is_enable: true,
    is_required: false,
    is_show: false,
    keyboard_type: "default",
    label: "Expected Installment Date",
    options: [],
    parent_depedencies: null,
    prefix: "",
    type: "date",
    validation: "",
    value: {}
}
export const DEALER_PRESENT_YES = 1;
export const DEALER_PRESENT_NO = 2;

export const ALLOW_LEAD_SOURCE = [3, 4];
export const DSA_LEAD_SOURCE = 5;
export const MARKETING_LEAD_SOURCE = 7;
export const INSTALLMENT = 2;
export const SIXTY_DAYS = 60;
export const SEVEN_DAYS = 7;
export const ENCRYPTED_FIELDS = ['per_full_address', 'cur_full_address', 'per_house_no', 'per_street', 'cur_house_no', 'cur_street'];
export const SOURCE_WEB = 2

export const ENCRYPTED_AGENCY_FIELDS = ['agency_name', 'branch_name', 'account_no', 'account_name', 'email'];


export const AGENCY_STATUS = {
    "inactive": 0,
    "active": 1,
    "inprogress": 2,
    "rejected": 3
}

export const AGENCY_DOC_STATUS = {
    "pending": 0,
    "approved": 1,
    "resubmit": 2,
    "rejected": 3,
    "deleted": 4
}


export const AGENCY_SOURCE = {
    "sfa": 1,
    "web": 2,
    "agentApp": 3
}

export const APP_AGENCY = 4
export const AGENCY_VAL = 4;

export const LEAD_TYPE_CRM = 4;
export const AGENCY_PREFILLED_KEYS = ['make', 'make_year', 'fuel_type', 'color', 'seat_capacity', 'name', 'per_full_address', 'cur_full_address']

export const REDIRECT_URLS: any = {
    "beta": "https://stage-sso.oto.com/google?redirect=",
    "preprod": "https://stage-sso.oto.com/google?redirect=",
    "prod": "https://sso.oto.com/google?redirect=",
    "local": "https://stage-sso.oto.com/google?redirect="
}
let reactAppEnv: any = process.env.REACT_APP_ENV;

export const REDIRECT_URL: any = REDIRECT_URLS[reactAppEnv]

export const DOC_UPLOAD_VALIDATION = { "minSize": 25000, "maxSize": 5000000 }

export const REFERRAL_FEE_PAYOUT_WHT_EXCLUSIVE_RATE = 0.9; //90%


export const INS_INSURANCE_ID_STAGE = true;
export const FEATURE_LISTING: any = {
    DASHBOARD: {
        CARDS: {
            pending_application: true,
            new_application: true,
            send_to_insurance_broker: true,
            soft_approval: false,
            insurance_policy: true,
            insurance_payment: false,
            incentive_payment: false,
            inbound_payment: true,
            outbound_payment: true,
            partner_payment: true,
            lost: true
        }
    },
    
    INSURANCE_LIST: {
        FILTERS: {
            SEARCH: true,
            INSURANCE_PARTNER: true,
            STATUS: true,
            SUB_STATUS: true,
            APPLICATION_TYPE: true,
            INSURER: true
        },
        MORE_FILTERS: {
            DATE_TYPE: true,
            DATE_RANGE: true,
            INSURANCE_TYPE: true,
            CREATED_BY: true,
            BUSINESS_LINE: false,
            USER_ROLE: false,
            USER_NAME: true,
            EMPLOYMENT_TYPE: false,
            LEAD_SOURCE: true,
            EFFECTIVITY_DATE: false,
            EXPIRY_DATE: false,
            PAYMENT_STATUS: false,
            RENEWAL_STATUS: false,
            DUE_DATE: false,
            SOURCE_TYPE: true,
            APPLICATION_METHOD: false,
            VEHICLE_USAGE:false,
            VEHICLE_TYPE:false,
            PRIORITY:false,
            MULTI_TENURE:true
        },
        ADD_NEW_APPLICATION: true,
        BULK_UPLOAD_APPLICATION: true,
        SUMMARY: {
            APPLICATION_TYPE: false,
            ASSIGN_TO: false,
            POLICY_DETAILS: {
                INSURANCE_TYPE: true
            },
            INSURER_NAME: true
        }
    },
    
    RULE_ENGINE: {
        CONFIGURATION: {
            email_template: true,
            user_management: true,
            partner_management: true,
            bulk_insurance_payment: false,
            insurance_agency_management: true,
            insurance_insurer_management: true,
            
        },
        
        IMPORT: false,
        
        UPDATE: false
    },
    
    LEAD_DETAILS: {
        RIBBON: {
            INSURANCE_ID: true,
            SOURCE_TYPE: true,
            APPLICATION_SUBMITTED_BY: true,
            HIERARCHY: true,
            CUSTOMER_DETAIL: true,
            CAR_DETAILS: true,
            CASE_STATUS: true,
            CASE_SUB_STATUS: true,
            INSURANCE_PARTNER: true,
            RAISED_SOA: false,
            DOC_STATUS: false,
            AGENCY_DETAILS: false,
            LOAN_ID: false,
            UCF_STATUS: false,
            UCF_SUB_STATUS: false,
            EMPLOYMENT_TYPE: false,
            PAYMENT_STATUS: false,
            DEALER_DETAILS: false,
            INSURER: true
        },
        INSURANCE_DETAILS: {
            CUSTOMER_DETAILS: {
                PERSONAL_DETAILS: {
                    CUSTOMER_NAME: true,
                    MOBILE: true,
                    ALTERNATE_MOBILE: true,
                    EMAIL: true,
                    MARITAL_STATUS: true,
                    GENDER: true,
                    DOB: true,
                    CITY_BIRTH: true,
                    KTP_ID: true,
                },
                COMPANY_DETAILS: {
                    NPWP_NO:true,
                    CUSTOMER_NAME: true,
                    MOBILE: true,
                    ALTERNATE_MOBILE: true,
                    EMAIL: true,
                },
                RESIDENTIAL_DETAILS: {
                    MAILING_ADDRESS: true,
                    KTP_ADDRESS: 'KTP Address',
                    COMPANY_ADDRESS:'COMPANY_ADDRESS',
                    HOUSING: true,
                    RT: true,
                    RW: true,
                    PROVINCE: true,
                    CITY: true,
                    DISTRICT: true,
                    SUB_DISTRICT: true,
                    SAME_AS_KTP_ADDRESS:'Same as KTP Address',
                    FULL_ADDRESS: false,
                    HOUSE_NO: false,
                    STREET: false,
                    REGION: false,
                    BARANGAY: false,
                    POSTAL_CODE: true,
                    PER_SAME_AS_CUR: false,
                    
                },
                VEHICLE_DETAILS: {
                    VEHICLE_TYPE: true,
                    PLATE_AREA: true,
                    PLATE_NUMBER_REGION: true,
                    MAKE: true,
                    MODEL: true,
                    VERSION: true,
                    MAKE_YEAR: true,
                    PLATE_NUMBER: true,
                    MACHINE_NUMBER: true,
                    CHASSIS_NUMBER: true,
                    FUEL_TYPE: true,
                    TRANSMISSION: true,
                    COLOR: true,
                    SEATING_CAPACITY: true,
                    MV_NUMBER: false,
                    ENGINE_CAPACITY:true,
                    MASTER_TYPE: true,
                    VEHICLE_CATEGORY: true
                    
                },
                OTHER_DETAILS: {
                    USAGE_TYPE: true,
                    VEHICLE_CONDITION: true,
                    INSURANCE_TYPE: false,
                    TENURE: true,
                    INSURANCE_STARTING_DATE: true,
                    CAR_UNDER_FINANCE: false,
                    FINANCIER: false,
                    INSURANCE_EXISTS: false,
                    LEAD_SOURCE: true,
                    LEAD_SUB_SOURCE: false,
                    REFERRER_INSURER_NAME: true,
                    REFERRER_INSURER_MOBILE: true,
                    DEALER: false,
                    PAID_BY_CUSTOMER_PAID_BY_WHOM: false,
                    INSURANCE_CATEGORY: true,
                    INSURANCE_LEAD_SOURCE: true,
                    POLICY_HOLDER: true
                },
                PAYMENT_DETAILS: false
            },
            SENT_TO_INSURANCE_BROKER: true,
            SOFT_APPROVAL_RECEIVED: false,
            INSURANCE_POLICY_GENERATED: true,
            POLICY_TERMS_FINALIZED: true,
            INSURANCE_PREMIUM_PAYMENT: true,
            INCENTIVE_PAYMENT: true,
            INSURANCE_POLICY_SHARED: true,
            PAYMENT_FROM_AGENCY_TO_OTO_INSURANCE: false,
            PAYMENT_FROM_OTO_TO_INSURANCE_PARTNER: false,
            PAYMENT_FROM_AGENCY_TO_INSURANCE_PARTNER: false,
            PAYMENT_FROM_AGENCY_TO_OTO: false,
            PAYMENT_FROM_INSURANCE_PARTNER_TO_OTO: false,
            REFERRAL_FEE_PAYOUT: false,
            PAYMENT_FROM_CUSTOMER_TO_BROKER: false,
            INBOUND_PAYMENT: {
                PAYMENT_FROM_CUSTOMER: true,
                PAYMENT_FROM_SALES_TEAM: true,
                PAYMENT_FROM_BROKER: true
            },
            OUTBOUND_PAYMENT: {
                PAYMENT_TO_BROKER: true,
                PAYMENT_TO_SALES_TEAM: true
            },
            INSURER_PARTNER_PAYMENT: true,
            DOCUMENT_RE_SUBMISSION: true
        },
        
        QUOTE_DETAILS: {
            VEHICLE_DETAILS: {
                VEHICLE_TYPE: true,
                VEHICLE_USAGE: false,
                PLATE_AREA: true,
                PLATE_NUMBER_REGION: true,
                MAKE: true,
                MODEL: true,
                VERSION: true,
                MAKE_YEAR: true,
                TENURE: false,
                CAR_FMV: false,
                PLATE_NUMBER: true,
                MACHINE_NUMBER: true,
                CHASSIS_NUMBER: true,
                FUEL_TYPE: true,
                TRANSMISSION: true,
                COLOR: true,
                SEATING_CAPACITY: true,
                MV_NUMBER: false,
                MASTER_TYPE: true,
                ENGINE_CAPACITY:true,
                VEHICLE_CATEGORY: true
            },
            SHARE_QUOTATION_WITH: {
                CUSTOMER: true,
                SALES_OFFICER: false,
                AGENT: false,
                ARO: false,
                SALES_MANAGER: false
            }
        },
        DOCUMENT_UPLOAD: {}
    }
}

export const FORM_SOW_TYPE:any = {
    'CUSTOMER' : 1, //CUSTOMER_TO_OTO
    'AGENCT'   : 2  //AGENT_TO_OTO
}

export const USER_MOBILE_REGEX             = /^[8]\d{7,11}$/;
export const REGEX_EMAIL                   = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const USER_EMAIL_REGEX              = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const USER_PASSWORD_REGEX           = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
export const REGEX_MOBILE                  = /^[8]\d{7,11}$/;
export const VP_ID                         = 1;
export const ALPHANUMERIC_PATTERN          = /^[a-z0-9]+$/i;






export const MAX_OTP_TIMER                = 59;
export const MAX_MOBILE_LENGTH = 10;
export const DEFAULT_INPUTFIELD_LENGTH = 1000;
export const DOCUMENT_RESUBMITTED = 2;
export const ADDON_PERSONAL_ACCIDENT = 3;
export const ROLE_IDS = { 'sm_id': 5, 'so_id': 6, 'aro_id': 7, 'agent_id': 8 }; 
export const MAX_UPLOAD_PAYMENT_PROOF = 5;
export const ROLE_NAME_VALIDATION = {min: 3, max: 30 };
export const DESCRIPTION_VALIDATION = {min: 3, max: 500};
export const USERLIST_MOBILE_REGEX = /^[0-9]{9,12}$/;
export const USERLIST_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const USER_NAME_VALIDATION = {min: 3, max: 30 };
export const DEFAULT_PAGINATION_COUNT = 10;
export const ACTIVE_INACTIVE_AGENCY = [0,1];



export const CURRENCY_CODE = 'id-ID';
export const WEBSITE_URL ='www.zeninsure.com'
export const PAYMENT_DONE_PREMIUN = 1;
export const PAYMENT_NOT_DONE_PREMIUN = 2;
export const DEFAULT_PAGE_NUMBER = 1;
export const ADDON_TANGGUNG        = 5;
export const API_VERSION_ID_PH = {ph : 'v2', id: 'v1'}

//merge 14147-48//
export const VEHICLE_CONDITION={'NEW':1,'USED':2}
export const POLICY_HOLDER={'PERSONAL':1,'COMPANY':2}
export const KB_INSURER_ID = 1;
export const ADDON_CODES ={0:'F',1:'UP',2:'JPUP'}
export const LEAD_DETAIL_AMOUNT_FIELDS = [
        'netCommissionDisbursal',
        'pointsValue',
        'cus_netcommissiondisbursal',
        'commissionValue',
        'grossWrittenPremium',
        'customerDiscountValue',
        'insurancePremiumAmount',
        'agentCommissionValue',
        'premiumExcludingAgentCommission',
        'excessAmountWithOTO',
        'totalPremiumAmountReceived',
        'transactionFeePaidByCustomer',
        'taxCommission',
        'cus_taxcommission',
        'total_addons_premium',
        'total_fmv',
        'admin_fee',
        'customer_discount',
        'agent_comission_amount',
        'agent_point_amount',
        'car_fmv',
        'acc_price',
        'basic_premium_amount',
        'final_premium',
        'transferFee',
        'gross_profit',
        'cash_customer',
        'gwp_amount',
        'offset_points_amt',
        'offset_points_amt_after_tax'
    ]
export const COND_SHOW_FIELDS_ACC_INSURERS = [16];
export const SENT_TO_VERIFICATION = {DONE:1,NOT_DONE:0};
export const SENT_TO_VERIFICATION_IDS = [2,3];
   
export const FUEL_TYPE_MAPPING:Record<string,any> ={
    '3':'Electric',
    '4':'Hybrid'
}
export const VEHICLE_TYPE ={
    EV:3,
    HYBRID:4
}
export const VEHICLE_USAGE_ID:any = {
    "Non Commercial": 1,
    "Commercial": 2,
}
export const DOC_IDS:any ={
    '1_1':[1,17,21],
    '1_2':[18,17,21],
    '2_1':[1,11,19,2,21],
    '2_2':[18,11,19,2,21]
}
export const VEHICLE_DOC_ID = 2;
export const EXISTING_POLICY_DOC_ID = 19;
export const ID_AGENT_ROLE_ID = 5;
   

export const FUEL_TYPE ={
    EV:'Electric',
    HYBRID:'Hybrid'
}
export const DISCOUNT_TYPE = {
    AMOUNT: 1,
    DISCOUNT: 2,
}
export const TENURE = 1;
export const QUOTATION_SHARE_TYPE = {QUOTATION_SHARE:1, QUOTATION_SHARE_NOT:2};
export const AUTHORIZED_WORKSHOP_ADDON_ID = 8;

export const DOC_ID = { KTP: 1, SELFIE_WITH_KTP: 2, NPWP: 3, BANK_STATEMENT: 2};
export const STATUS_FIELD = { ACTIVE: 1, IN_ACTIVE: 0 };
export const STATUS_SUCCESS = 200
export const PAGE_NUMBER = 1; 
export const SKIP_ENCRYPTION_ROUTE_KEYWORDS = ["Insurer/editInsurer","Insurer/addInsurer","agency/api/uploadLeadDocImagesId"]
export const INSURER_STATUS ={
    INACTIVE:2
}
export const AGENTCOM_OVER_LAP_ERRORS=['Overlapping Age/Make found','Tumpang tindih Usia/Merek']
export const VEHICLE_CATEGORY={
    NON_BUS_NON_TRUCK:1,
    BUS_TRUCK_PICKUP:3
}

export const INSURANCE_EXISTS = { YES: 1, NO: 2 };
export const ALLOW_ALPHABET = /^[A-Za-z\s]+$/
export const INSURER_EXCLUDE_ID = [7,8]
export const VALID_LEAD_SOURCE_FOR_ID =  [2,3,7,8]
export const ACTION_STATUS = 1;
export const EMAIL_DOMAINS = ["zeninsure", "carmudi"];
export const SUBTRACT_YEAR = { ONE: 1, TWO: 2 , THREE: 3, SIX: 6 }; 
export const ALLOW_MONTH = 6
export const ALLOWED_DOB_LIMIT = 90
export const LAST_MONTH = 11
export const LEAD_SOURCE_AGENCY = 1
export const VERIFIED_STATUS = 4; 
export const VEHICLE_CHILD_IDS=[3,4,5,6,7,8,9]
export const IS_HQ=1
export const TEMPLATE_TYPE ={
    EMAIL:1,
    WP:2
}
export const ROLE_ID={
 BM:4
}
export const SELECTED_TENURE_YEAR=1
export const BACK_ORDER_APPLICATION = 22;
